<script>
import moment from "moment";
import VueApexCharts from "vue-apexcharts";
import {
  consultarDisponibilidad,
  agendarCita
} from "../../apiService/request/Agendamiento";
import mixinScroll from "../../js/mixins/mixinScroll.js";
import Agendar from "../../components/Agendar/Agendar";
export default {
  components: {
    apexcharts: VueApexCharts,
    Agendar,
  },
  created: async function() {
    await this.consultarLaDisponibilidad(this.semana);
    this.$store.dispatch("setFechaHoraCita", null);
  },
  data: function() {
    return {
      switch1:false,
      valid: false,
      consultando: false,
      componentKey: 0,
      semana: 1,
      options: {},
      series: [],
      horarios: null,
      horaSelected: "",
      descripcion: "",
      telefono: this.$store.getters.getTelefonoPaciente,
      reglasTelefono: [
        v => !!v || "El telefono es requerido",
        v =>
          (v && v.toString().length >= 7) ||
          "El telefono debe tener 7 o más caracteres"
      ]
    };
  },
  filters: {
    moment: function(date, format) {
      var fecha = isNaN(date) ? date : Number(date);
      return moment(fecha).format(format);
    }
  },
  mounted() {
    this.horaSelected = "";
  },
  computed: {
    getFechaHoraCita() {
      if (this.$store.getters.getFechaHoraCita) {
        this.horaSelected = this.$store.getters.getFechaHoraCita;
      }
      return this.$store.getters.getFechaHoraCita;
    }
  },
  mixins:[
    mixinScroll
  ],
  props: {
    confirmarCita:{
      type: Boolean
    }
  },
  watch: {
    getFechaHoraCita() {}
  },
  methods: {
    forceRerender() {
      this.componentKey += 1;
    },
    async consultarLaDisponibilidad(semana) {
      const categories = [];
      const series = [];
      this.week = await consultarDisponibilidad(
        this.$store.getters.getEvento,
        semana,
        this.$store.getters.getSede
      ).then(res => res.data.data);
      this.week.forEach(day => {
        categories.push(day.dia);
        series.push(day.valor);
      });

      const maximo = Math.max.apply(null, series);
      let max = maximo +  Math.round(Math.max.apply(null, series) * 0.3);
      // console.log('max',max);
      this.options = {
        chart: {
          type: "bar",
          height: 350,
          stacked: true,
          toolbar: {
            show: false
          },
          events: {
            dataPointSelection: this.clickGraphic
          }
        },
        legend: {
          show: false
        },
        states: {
          active: {
            allowMultipleDataPointsSelection: false,
            filter: {
              type: "darken",
              value: 0.3
            }
          }
        },
        // colors: ["#3A5FBA", "#3D88C4", "#3F9AAE"],
        colors: [
          "#579FF2",
          "#946EEB",
          "#90A4AE",
          "#F0706C",
          "#B7C53B",
          // "#F38D89",
          "#D493B0",
          "#45B8DD",
          "#BA567C",
          "#3ABA8B",
          "#55669F",
          "#EFE18B",
          "#ED8432",
          "#F0AE7B"
        ],
        dataLabels: {
          // enabled: true,
          textAnchor: "center",
          style: {
            colors: ["#fff"],
            fontSize: 15
          },
          offsetX: 0
        },
        grid: {
          row: {
            colors: ["#F4F5F8"]
          }
        },
        xaxis: {
          categories: categories,
          labels: {
            style: {
              colors: ["#646a6f"],
              fontSize: "16px",
              fontFamily: "Nunito, sans-serif"
            },
            min: 20,
            formatter: function(value) {
              // if (value) {
              //   const str = value.toString();
              //   return str.charAt(0).toUpperCase() + str.slice(1);
              // }
              return Math.ceil(value)
            }
          }
        },
        fill: {
          type: "gradient",
          gradient: {
            shade: "light"
          }
        },
        plotOptions: {
          bar: {
            distributed: true,
            horizontal: true,
            dataLabels: {}
          },
          colors: ["#3D88C4"]
        },
        yaxis: {
          max:  max,
          labels: {
            // show: false,
            style: {
              fontSize: 20 /**El texto de la izquierda de la grafica */,
              fontSize: "16px",
              fontFamily: "Nunito, sans-serif"
            }
          }
        }
      };
      this.series = [
        {
          data: series
        }
      ];
    },
    dispatchTelefonoPaciente() {
      this.$store.dispatch("setTelefonoPaciente", Number(this.telefono));
    },
    clickGraphic(event, chartContext, config) {
      this.$store.dispatch("setFechaHoraCita", null);
      this.horarios = this.week[config.dataPointIndex].horario;
      this.forceRerender();
    },
    async confirmar() {
      if (
        this.$refs &&
        this.$refs.formAgendamiento &&
        this.$refs.formAgendamiento.validate()
      ) {
        this.consultando = true;
        const data = {
          documento: this.$store.getters.getCedulaPaciente,
          key: this.$store.getters.getEvento,
          fechaHoraCita: this.horaSelected,
          nombrePaciente: this.$store.getters.getNombrePaciente,
          telefono: this.$store.getters.getTelefonoPaciente,
          nombrePrestacion: this.$store.getters.getNombrePrestacion,
          agendadoPor: this.$store.state.provider_email,
          ordenId: this.$store.getters.getOrdenId,
          cups: this.$store.getters.getCups.toString(),
          sede: this.$store.getters.getSede,
          descripcion: this.descripcion
        };

        const respuesta = await agendarCita(data)
          .then(res => res)
          .catch(err => err);

        this.$store.dispatch("cambiarEstadoModal", true);
        this.$store.dispatch("cambiarMensajeModal", respuesta);

       
        this.consultando = true;
        if (this.confirmarCita == false) {
          // this.$emit('mostrarAgenadamientoConfirmaCita')
           this.$store.dispatch("setMensajeChatBox", "Salir de Agendamiento"); 
        } else {
            this.$emit('mostrarAgenadamientoConfirmaCita')

        }
      }
    },
    confirmarCitaAbierto(){
      this.$emit('mostrarAgenadamientoConfirmaCita')
      console.log('confirmarcitaagendamiento');
      

    },
    async semanaActual() {
      this.semana = 1;
      await this.consultarLaDisponibilidad(this.semana);
    },
    async prev() {
      this.semana -= 1;
      await this.consultarLaDisponibilidad(this.semana);
      this.forceRerender();
    },
    async next() {
      this.semana += 1;
      await this.consultarLaDisponibilidad(this.semana);
      this.forceRerender();
    },
    // focoBoton() {
    //   let scrollAgendamiento = document.getElementById('btnConfirmar').offsetTop;
    //   let item2Comprimido = document.getElementsByClassName("item2Comprimido");
    //   item2Comprimido[0].scrollTop = scrollAgendamiento;
      
    // }
  }
};
</script>

<template src="./Agendamiento.html"></template>
<style lang="scss" src="./Agendamiento.scss"></style>


// WEBPACK FOOTER //
// src/components/Agendamiento/Agendamiento.vue